import styled from '@emotion/styled'

const YearSelector = styled.select`
  margin: 1rem 0;
  padding: 0.5rem;
  border: 2px solid ${(props) => props.theme.colors.gray};
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors.white};
  font-size: ${(props) => props.theme.fontSizes[2]};
  color: ${(props) => props.theme.colors.black};
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.blue};
  }
`
export default YearSelector
